import {
  Bold,
  Italic,
  Strike,
  Underline,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  HorizontalRule,
  History,
  HardBreak
} from 'tiptap-vuetify';

export default [
  History,
  Bold,
  Italic,
  Underline,
  Strike,
  ListItem,
  BulletList,
  OrderedList,
  HorizontalRule,
  Link,
  HardBreak
];
